import React from "react";
import { EvaluationCriteria } from "../../../model_gen/evaluation";

interface RubricConfig {
  scoring_type?: string;
  min?: number;
  max?: number;
  levels?: { value: number; label: string; description: string }[];
  tags?: { value: string; label: string; description: string }[];
  pass_description?: string;
  fail_description?: string;
}

export function renderCriteriaTooltip(
  crit: EvaluationCriteria
): React.ReactNode {
  const cfg = (crit.config || {}) as RubricConfig;
  const desc = crit.instructions || "";

  if (cfg.scoring_type === "numeric" && cfg.levels?.length) {
    return (
      <div className="flex gap-5 min-w-[480px]">
        <div className="w-[220px] shrink-0">
          <p className="text-sm leading-relaxed">{desc}</p>
        </div>
        <div className="flex-1 border-l border-white/10 pl-4">
          <div className="text-xs text-white/50 mb-1">
            Scale: {cfg.min ?? 1} – {cfg.max ?? 5}
          </div>
          <table className="text-xs">
            <tbody>
              {cfg.levels.map((l) => (
                <tr key={l.value}>
                  <td className="pr-2 py-0.5 font-semibold text-white whitespace-nowrap">
                    {l.value} — {l.label}
                  </td>
                  <td className="py-0.5 text-white/70">{l.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (cfg.scoring_type === "tags" && cfg.tags?.length) {
    return (
      <div className="flex gap-5 min-w-[480px]">
        <div className="w-[220px] shrink-0">
          <p className="text-sm leading-relaxed">{desc}</p>
        </div>
        <div className="flex-1 border-l border-white/10 pl-4">
          <div className="text-xs text-white/50 mb-1">Tags</div>
          <table className="text-xs">
            <tbody>
              {cfg.tags.map((t) => (
                <tr key={t.value}>
                  <td className="pr-2 py-0.5 font-semibold text-white whitespace-nowrap">
                    {t.label || t.value}
                  </td>
                  <td className="py-0.5 text-white/70">{t.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (cfg.scoring_type === "boolean") {
    return (
      <div className="flex gap-5 min-w-[400px]">
        <div className="w-[220px] shrink-0">
          <p className="text-sm leading-relaxed">{desc}</p>
        </div>
        <div className="flex-1 border-l border-white/10 pl-4 text-xs space-y-1.5">
          {cfg.pass_description && (
            <div>
              <span className="font-semibold text-green-400">Pass: </span>
              <span className="text-white/70">{cfg.pass_description}</span>
            </div>
          )}
          {cfg.fail_description && (
            <div>
              <span className="font-semibold text-red-400">Fail: </span>
              <span className="text-white/70">{cfg.fail_description}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return <p className="text-sm leading-relaxed max-w-sm">{desc}</p>;
}
